import { useAtom } from '@reatom/npm-react'

import { WalletAssetsBalanceCell } from '@root/entities/wallet/ui/table/column/wallet-asset-column/wallet-assets-balance-cell'

import type { WalletAssetModel } from '@root/entities/wallet'

type Props = {
  asset: WalletAssetModel
}

export const WalletAssetsTableBalanceCell: React.FC<Props> = ({ asset }) => {
  const [balance] = useAtom(asset.balance)
  const [balanceUsd] = useAtom(asset.balanceUsd)

  return (
    <WalletAssetsBalanceCell
      ticker={asset.currency.ticker}
      balance={balance}
      balanceUsd={balanceUsd}
    />
  )
}
